import HeroCarousel from "./components/HeroCarousel";
import LatestNews from "./components/LatestNews";
import FeaturedWorks from "./components/FeaturedWorks";
import AboutIntro from "./components/AboutIntro";
import usePageMeta from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "森泽佳奈官网 - 最新资讯与作品介绍",
    description:
      "森泽佳奈官方网站，提供她的最新动态、个人资料和作品详情，涵盖影视音乐等多领域信息，帮助您全面了解森泽佳奈。",
    keywords: "森泽佳奈,森泽佳奈作品,森泽佳奈资讯,森泽佳奈介绍,森泽佳奈动态,森泽佳奈个人资料",
  });

  return (
    <>
      <h1 className="sr-only">森泽佳奈 - 个人品牌官方网站</h1>
      <HeroCarousel />
      <LatestNews />
      <FeaturedWorks />
      <AboutIntro />
    </>
  );
}